<div class="subscribe-area-new pt-2 pb-2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6"></div>

            <div class="col-lg-6 col-md-6">
                <div class="showimg">
                    <img src="assets/img/cat-search2.jpg" alt="image">
                </div>
                <form class="newsletter-form-new" (ngSubmit)="searchQuestByName()">
                    <input type="text"
                    class="input-newsletter-new"
                    placeholder="Nhập tên Quest"
                    name="TEXT"
                    autocomplete="off"
                    [(ngModel)]="questName">

                    <button type="submit" class="default-btn">Tìm kiếm<span></span></button>
                </form>
            </div>
        <!-- </div> -->
    </div>
</div>
